import './assets/sass/main.scss' 
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import VueMobileDetection from "vue-mobile-detection";
 const pinia = createPinia()
 const app = createApp(App)
 app.use(pinia).use(router).use(VueMobileDetection)
 // Initialize the user store
import { useUserStore } from './stores/userStore'
const userStore = useUserStore()
userStore.initializeStore()
app.mount('#app')



